export const DEFAULT_CSV_SEPARATOR = ',';

export const DOWNLOAD_EXCEL = 'DOWNLOAD TO EXCEL';
